import { render, staticRenderFns } from "./reporte_permisovacacion.vue?vue&type=template&id=0bebb250&scoped=true"
import script from "./reporte_permisovacacion.vue?vue&type=script&lang=js"
export * from "./reporte_permisovacacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bebb250",
  null
  
)

export default component.exports